(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  (function() {
    var hamburger = document.getElementById('header-hamburger');
    var drawer = document.getElementById('nav-drawer');
    var overlay = document.getElementById('drawer-overlay');
    var closeBtn = document.getElementById('drawer-close');

    function openDrawer() {
      drawer.classList.add('is-open');
      overlay.classList.add('is-open');
      hamburger.setAttribute('aria-expanded', 'true');
      drawer.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }

    function closeDrawer() {
      drawer.classList.remove('is-open');
      overlay.classList.remove('is-open');
      hamburger.setAttribute('aria-expanded', 'false');
      drawer.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }

    if (hamburger) hamburger.addEventListener('click', openDrawer);
    if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
    if (overlay) overlay.addEventListener('click', closeDrawer);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["how-it-works-home"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var steps = document.querySelectorAll('.hiw__step');
    if (!steps.length || !window.IntersectionObserver) {
      [].forEach.call(steps, function (s) { s.classList.add('is-visible'); });
      return;
    }
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.2 });
    [].forEach.call(steps, function (s) { observer.observe(s); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["oxyvia-calculator"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var calcEl = document.querySelector('.product-calc');
    if (!calcEl) return;
    var monthlyOxy = parseFloat(calcEl.getAttribute('data-monthly-price')) || 39;
    var priceIn = document.getElementById('calc-pack-price');
    var packsIn = document.getElementById('calc-packs-week');
    function fmt(n) { return n.toFixed(2).replace('.', ',') + ' €'; }
    function set(id, val) { var el = document.getElementById(id); if (el) el.textContent = val; }
    function calc() {
      var pp = parseFloat(priceIn.value) || 10;
      var pw = parseFloat(packsIn.value) || 1;
      var cigW = pp * pw, cigM = cigW * 4.33, cigY = cigW * 52;
      var oxyW = monthlyOxy / 4.33, oxyM = monthlyOxy, oxyY = monthlyOxy * 12;
      set('calc-week-cig',  fmt(cigW));  set('calc-week-oxy',  fmt(oxyW));  set('calc-week-save',  fmt(Math.max(0, cigW - oxyW)));
      set('calc-month-cig', fmt(cigM));  set('calc-month-oxy', fmt(oxyM));  set('calc-month-save', fmt(Math.max(0, cigM - oxyM)));
      set('calc-year-cig',  fmt(cigY));  set('calc-year-oxy',  fmt(oxyY));  set('calc-year-save',  fmt(Math.max(0, cigY - oxyY)));
    }
    priceIn.addEventListener('input', calc);
    packsIn.addEventListener('input', calc);
    document.querySelectorAll('.product-calc__step').forEach(function (btn) {
      btn.addEventListener('click', function () {
        packsIn.value = Math.max(1, Math.min(30, (parseInt(packsIn.value) || 1) + parseInt(this.getAttribute('data-step'))));
        calc();
      });
    });
    calc();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["oxyvia-comparison"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    var tabs = document.querySelectorAll('.pdct-tab');

    tabs.forEach(function(tab) {
      tab.addEventListener('click', function() {
        var targetCol = this.dataset.pdctGo;

        tabs.forEach(function(t) {
          t.classList.remove('is-active');
          t.setAttribute('aria-pressed', 'false');
        });
        this.classList.add('is-active');
        this.setAttribute('aria-pressed', 'true');

        document.querySelectorAll('.pdct-col-slide').forEach(function(cell) {
          if (cell.dataset.pdctColumn === targetCol) {
            cell.classList.remove('pdct-hidden');
          } else {
            cell.classList.add('pdct-hidden');
          }
        });
      });
    });

    if (tabs.length > 0) tabs[0].click();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["oxyvia-journey"] && !Shopify.designMode) return;
  try {
    
(function () {
  var steps = document.querySelectorAll('.oxyvia-journey__step');
  if (!steps.length) return;
  if (!('IntersectionObserver' in window)) {
    steps.forEach(function (el) { el.classList.add('is-visible'); });
    return;
  }
  var obs = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) {
        e.target.classList.add('is-visible');
        obs.unobserve(e.target);
      }
    });
  }, { threshold: 0.15 });
  steps.forEach(function (el) { obs.observe(el); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["oxyvia-testimonials"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initCarousel(root) {
      var sid = root.dataset.section;
      var infinite = root.dataset.infinite === 'true';
      var navStyle = root.dataset.navStyle;
      var navPos = root.dataset.navPosition;

      var track = document.getElementById('oxyvia-testi-track-' + sid);
      var stage = document.getElementById('oxyvia-testi-stage-' + sid);
      var navEl = document.getElementById('oxyvia-testi-nav-' + sid);
      if (!track) return;

      var realCards = Array.from(track.querySelectorAll('[data-index]'));
      var count = realCards.length;
      if (count <= 1) return;

      var active = 0;

      /* ── Infinite: clone first/last cards as boundary sentinels ── */
      if (infinite) {
        var headClone = realCards[count - 1].cloneNode(true);
        headClone.removeAttribute('data-index');
        headClone.setAttribute('aria-hidden', 'true');
        track.insertBefore(headClone, track.firstChild);

        var tailClone = realCards[0].cloneNode(true);
        tailClone.removeAttribute('data-index');
        tailClone.setAttribute('aria-hidden', 'true');
        track.appendChild(tailClone);

        track.scrollTo({ left: realCards[0].offsetLeft, behavior: 'instant' });
      }

      /* ── Helpers ── */
      function scrollToCard(card, smooth) {
        track.scrollTo({ left: card.offsetLeft, behavior: smooth ? 'smooth' : 'instant' });
      }

      function updateActive(idx) {
        active = (idx + count) % count;
        realCards.forEach(function (c) { c.classList.remove('is-active'); });
        if (realCards[active]) realCards[active].classList.add('is-active');
        if (!navEl) return;
        navEl.querySelectorAll('[data-idx]').forEach(function (btn) {
          btn.classList.toggle('is-active', parseInt(btn.dataset.idx) === active);
        });
      }

      function goTo(idx) {
        var norm = ((idx % count) + count) % count;
        active = norm;
        updateActive(norm);
        scrollToCard(realCards[norm], true);
      }

      /* ── Build navigation ── */
      if (navStyle === 'arrows') {
        var prevSVG = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 18 9 12 15 6"/></svg>';
        var nextSVG = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg>';

        var prevBtn = document.createElement('button');
        prevBtn.type = 'button';
        prevBtn.className = 'oxyvia-testi__arrow oxyvia-testi__arrow--prev';
        prevBtn.setAttribute('aria-label', 'Προηγούμενο');
        prevBtn.innerHTML = prevSVG;

        var nextBtn = document.createElement('button');
        nextBtn.type = 'button';
        nextBtn.className = 'oxyvia-testi__arrow oxyvia-testi__arrow--next';
        nextBtn.setAttribute('aria-label', 'Επόμενο');
        nextBtn.innerHTML = nextSVG;

        prevBtn.addEventListener('click', function () { goTo(active - 1); });
        nextBtn.addEventListener('click', function () { goTo(active + 1); });

        if (navPos === 'sides') {
          stage.insertBefore(prevBtn, track);
          stage.appendChild(nextBtn);
          stage.classList.add('oxyvia-testi__stage--sides');
        } else {
          navEl.classList.add('oxyvia-testi__nav--arrows');
          navEl.appendChild(prevBtn);
          navEl.appendChild(nextBtn);
        }

      } else if (navStyle !== 'none') {
        var btnClass = navStyle === 'dots' ? 'oxyvia-testi__dot'
                     : navStyle === 'dashes' ? 'oxyvia-testi__dash'
                     : 'oxyvia-testi__num';

        for (var i = 0; i < count; i++) {
          (function (idx) {
            var btn = document.createElement('button');
            btn.type = 'button';
            btn.className = btnClass + (idx === 0 ? ' is-active' : '');
            btn.setAttribute('data-idx', idx);
            btn.setAttribute('aria-label', 'Μαρτυρία ' + (idx + 1));
            if (navStyle === 'numbers') btn.textContent = idx + 1;
            btn.addEventListener('click', function () { goTo(idx); });
            navEl.appendChild(btn);
          })(i);
        }

        if (navPos === 'sides') navEl.classList.add('oxyvia-testi__nav--vertical');
      }

      updateActive(0);

      /* ── Scroll tracking + infinite teleport ── */
      var scrollTimer;
      track.addEventListener('scroll', function () {
        clearTimeout(scrollTimer);
        scrollTimer = setTimeout(function () {
          var allC = Array.from(track.children);
          var cloneOffset = infinite ? 1 : 0;
          var center = track.scrollLeft + track.clientWidth / 2;

          var closest = 0, minDist = Infinity;
          for (var i = 0; i < count; i++) {
            var c = allC[i + cloneOffset];
            if (!c) continue;
            var dist = Math.abs(c.offsetLeft + c.offsetWidth / 2 - center);
            if (dist < minDist) { minDist = dist; closest = i; }
          }
          updateActive(closest);

          if (infinite) {
            var headEl = allC[0];
            var tailEl = allC[allC.length - 1];
            if (center >= tailEl.offsetLeft + tailEl.offsetWidth / 2 - 10) {
              track.scrollTo({ left: realCards[0].offsetLeft, behavior: 'instant' });
              active = 0; updateActive(0);
            } else if (center <= headEl.offsetLeft + headEl.offsetWidth / 2 + 10) {
              track.scrollTo({ left: realCards[count - 1].offsetLeft, behavior: 'instant' });
              active = count - 1; updateActive(count - 1);
            }
          }
        }, 80);
      }, { passive: true });
    }

    document.querySelectorAll('[data-testi]').forEach(initCarousel);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["oxyvia-topbar"] && !Shopify.designMode) return;
  try {
    
(function () {
  var btn = document.querySelector('.oxyvia-topbar__badge');
  if (!btn || !navigator.clipboard) return;
  btn.addEventListener('click', function () {
    navigator.clipboard.writeText(btn.dataset.code).then(function () {
      var orig = btn.textContent;
      btn.textContent = btn.dataset.copied || 'Copié ✓';
      setTimeout(function () { btn.textContent = orig; }, 2000);
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  (function () {

    /* ── Gallery ──────────────────────────────────────── */
    document.querySelectorAll('.product-gallery').forEach(function (gallery) {
      var thumbs = gallery.querySelectorAll('[data-gallery-thumb]');
      var slides = gallery.querySelectorAll('[data-gallery-slide]');
      var mainEl = gallery.querySelector('.product-gallery__main');
      var total = slides.length;
      var current = 0;

      function isMobile() { return window.innerWidth <= 767; }

      function setActiveThumb(idx) {
        thumbs.forEach(function (t) { t.classList.remove('is-active'); });
        var th = gallery.querySelector('[data-gallery-thumb="' + idx + '"]');
        if (th) th.classList.add('is-active');
      }

      function goTo(idx) {
        current = (idx + total) % total;
        setActiveThumb(current);
        if (isMobile() && mainEl) {
          mainEl.scrollTo({ left: current * mainEl.offsetWidth, behavior: 'smooth' });
        } else {
          slides.forEach(function (s) { s.classList.remove('is-active'); s.setAttribute('aria-hidden', 'true'); });
          var active = gallery.querySelector('[data-gallery-slide="' + current + '"]');
          if (active) { active.classList.add('is-active'); active.setAttribute('aria-hidden', 'false'); }
          /* Scroll thumbs strip: keep active thumb visible + hint at next */
          var thumbsEl = gallery.querySelector('.product-gallery__thumbs');
          var th = gallery.querySelector('[data-gallery-thumb="' + current + '"]');
          if (thumbsEl && th) {
            var cRect = thumbsEl.getBoundingClientRect();
            var tRect = th.getBoundingClientRect();
            var tRelLeft = tRect.left - cRect.left + thumbsEl.scrollLeft;
            var tRelRight = tRect.right - cRect.left + thumbsEl.scrollLeft;
            /* Target current+2 to trigger scroll 2 images earlier */
            var nextTh = gallery.querySelector('[data-gallery-thumb="' + (current + 2) + '"]')
                      || gallery.querySelector('[data-gallery-thumb="' + (current + 1) + '"]');
            var target;
            if (nextTh) {
              var nRect = nextTh.getBoundingClientRect();
              var nRelRight = nRect.right - cRect.left + thumbsEl.scrollLeft;
              /* Scroll so target thumb is ~40% visible on the right edge */
              target = nRelRight - thumbsEl.clientWidth + nextTh.offsetWidth * 0.6;
            } else {
              /* Last thumb: ensure it's fully visible */
              target = tRelRight - thumbsEl.clientWidth + 8;
            }
            thumbsEl.scrollTo({ left: Math.max(0, target), behavior: 'smooth' });
          }
        }
      }

      thumbs.forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          goTo(parseInt(this.getAttribute('data-gallery-thumb'), 10));
        });
      });

      if (mainEl) {
        mainEl.addEventListener('scroll', function () {
          if (!isMobile()) return;
          current = Math.round(mainEl.scrollLeft / mainEl.offsetWidth);
          setActiveThumb(current);
        });
      }
    });

    /* ── Urgency counter ──────────────────────────────── */
    var viewerEl = document.getElementById('product-viewers');
    if (viewerEl) {
      viewerEl.textContent = Math.floor(Math.random() * 17) + 12;
    }

    /* ── Savings calculator ───────────────────────────── */
    var calcEl = document.querySelector('.product-calc');
    if (calcEl) {
      var monthlyOxy = parseFloat(calcEl.getAttribute('data-monthly-price')) || 39;
      var priceIn  = document.getElementById('calc-pack-price');
      var packsIn  = document.getElementById('calc-packs-week');

      function fmt(n) { return n.toFixed(2).replace('.', ',') + ' €'; }
      function set(id, val) { var el = document.getElementById(id); if (el) el.textContent = val; }

      function calc() {
        var pp = parseFloat(priceIn.value) || 10;
        var pw = parseFloat(packsIn.value) || 1;
        var cigW = pp * pw;
        var cigM = cigW * 4.33;
        var cigY = cigW * 52;
        var oxyW = monthlyOxy / 4.33;
        var oxyM = monthlyOxy;
        var oxyY = monthlyOxy * 12;
        set('calc-week-cig',   fmt(cigW));   set('calc-week-oxy',   fmt(oxyW));   set('calc-week-save',  fmt(Math.max(0, cigW - oxyW)));
        set('calc-month-cig',  fmt(cigM));   set('calc-month-oxy',  fmt(oxyM));   set('calc-month-save', fmt(Math.max(0, cigM - oxyM)));
        set('calc-year-cig',   fmt(cigY));   set('calc-year-oxy',   fmt(oxyY));   set('calc-year-save',  fmt(Math.max(0, cigY - oxyY)));
      }

      priceIn.addEventListener('input', calc);
      packsIn.addEventListener('input', calc);
      document.querySelectorAll('.product-calc__step').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var current = parseInt(packsIn.value) || 1;
          packsIn.value = Math.max(1, Math.min(30, current + parseInt(this.getAttribute('data-step'))));
          calc();
        });
      });
      calc();
    }

    /* ── Scroll animations ────────────────────────────── */
    if ('IntersectionObserver' in window) {
      var sel = [
        '.oxyvia-faq__inner', '.oxyvia-faq__list',
        '.oxyvia-testi__head', '.oxyvia-testi__track',
        '.oxyvia-journey__inner',
        '.oxyvia-ingr__head', '.oxyvia-ingr__track',
        '.oxyvia-htu__inner',
        '.oxyvia-cmp__inner',
        '.oxyvia-cta__inner',
        '.oxyvia-ugc__head', '.oxyvia-ugc__grid',
        '.oxyvia-email__inner'
      ].join(',');

      var els = document.querySelectorAll(sel);
      els.forEach(function (el) { el.classList.add('oxyvia-anim'); });

      var obs = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('is-visible'); obs.unobserve(e.target); }
        });
      }, { threshold: 0.12 });

      els.forEach(function (el) { obs.observe(el); });
    }

    /* ── Testimonial carousel ─────────────────────────── */
    document.querySelectorAll('[data-crc]').forEach(function(wrap) {
      var track = wrap.querySelector('[data-crc-track]');
      var cards = Array.prototype.slice.call(track.querySelectorAll('.crc-card'));
      var prevBtn = wrap.querySelector('[data-crc-prev]');
      var nextBtn = wrap.querySelector('[data-crc-next]');
      var total = cards.length;
      var current = 0;
      var locked = false;

      /* Clone first card and append for seamless forward loop */
      var clone = cards[0].cloneNode(true);
      track.appendChild(clone);

      function slide(idx, animate) {
        if (animate === false) track.style.transition = 'none';
        current = idx;
        track.style.transform = 'translateX(-' + (current * cards[0].offsetWidth) + 'px)';
        if (animate === false) {
          track.offsetHeight;
          track.style.transition = '';
        }
        if (prevBtn) prevBtn.setAttribute('aria-disabled', current === 0 ? 'true' : 'false');
        if (nextBtn) nextBtn.setAttribute('aria-disabled', 'false');
      }

      slide(0, false);
      window.addEventListener('resize', function() { slide(current, false); });

      if (nextBtn) nextBtn.addEventListener('click', function() {
        if (locked) return;
        locked = true;
        var next = current + 1;
        slide(next);
        /* After reaching clone (index = total), jump silently to index 0 */
        track.addEventListener('transitionend', function handler() {
          track.removeEventListener('transitionend', handler);
          if (current === total) slide(0, false);
          locked = false;
        });
      });

      if (prevBtn) prevBtn.addEventListener('click', function() {
        if (locked) return;
        locked = true;
        slide(current > 0 ? current - 1 : 0);
        track.addEventListener('transitionend', function handler() {
          track.removeEventListener('transitionend', handler);
          locked = false;
        });
      });

      /* Touch swipe */
      var touchStartX = 0;
      wrap.addEventListener('touchstart', function(e) {
        touchStartX = e.touches[0].clientX;
      }, { passive: true });
      wrap.addEventListener('touchend', function(e) {
        var diff = touchStartX - e.changedTouches[0].clientX;
        if (Math.abs(diff) > 40) {
          if (diff > 0 && nextBtn) nextBtn.click();
          else if (diff < 0 && prevBtn) prevBtn.click();
        }
      });
    });

    document.querySelectorAll('.pnative__qty-btn').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var input = this.closest('.pnative__qty-control').querySelector('.pnative__qty-input');
        var val = parseInt(input.value, 10) || 1;
        if (this.dataset.action === 'increment') {
          input.value = val + 1;
        } else if (val > 1) {
          input.value = val - 1;
        }
      });
    });

  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials-home"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-th]').forEach(function (root) {
      var track = root.querySelector('.th__track');
      var total = track.querySelectorAll('.th__card-wrap').length;
      var dots = root.querySelectorAll('.th__dot');
      var pos = 0;
      var timer;

      function pv() { return window.innerWidth < 768 ? 1 : 3; }

      function go(newPos, animate) {
        var perView = pv();
        var max = Math.max(0, total - perView);
        pos = newPos < 0 ? max : newPos > max ? 0 : newPos;
        track.style.transition = animate ? 'transform 0.45s ease' : 'none';
        track.style.transform = 'translateX(-' + (100 / perView * pos) + '%)';
        [].forEach.call(dots, function (d, i) {
          d.classList.toggle('th__dot--active', i === pos);
        });
      }

      function next() { go(pos + 1, true); }
      function prev() { go(pos - 1, true); }

      function startAuto() {
        clearInterval(timer);
        timer = setInterval(next, 4500);
      }

      root.querySelector('.th__arrow--next').addEventListener('click', function () { next(); startAuto(); });
      root.querySelector('.th__arrow--prev').addEventListener('click', function () { prev(); startAuto(); });

      [].forEach.call(dots, function (dot, i) {
        dot.addEventListener('click', function () { go(i, true); startAuto(); });
      });

      var startX = 0;
      var vp = root.querySelector('.th__viewport');
      vp.addEventListener('touchstart', function (e) { startX = e.changedTouches[0].clientX; }, { passive: true });
      vp.addEventListener('touchend', function (e) {
        var dx = e.changedTouches[0].clientX - startX;
        if (Math.abs(dx) > 40) { dx < 0 ? next() : prev(); startAuto(); }
      }, { passive: true });

      window.addEventListener('resize', function () { go(pos, false); });

      go(0, false);
      startAuto();
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
